import { connect } from 'react-redux';
import AsyncHeader from './AsyncHeader';

const mapStateToProps = ({
  system: { siteName, isTouchDevice },
  intl: { locale },
  user: { isUserLogged },
  content: { header: data }
}) => ({
  siteName,
  locale,
  isTouchDevice,
  isUserLogged,
  data
});

export default connect(mapStateToProps, null)(AsyncHeader);



// WEBPACK FOOTER //
// ./src/universal/components/Header/index.js